export default __webpack_public_path__ + "static/poster3-5926e39732d8ee0617965f621a4d7be3.webp";